const urlsBySpecies = {
  dog: [
    '/dog-insurance/',
    '/guides-and-advice/dog-breeds-with-the-shortest-lifespan/',
    '/agria-dog-insurance/',
    '/gun-dog-insurance-basc/',
    '/service-dog-insurance/',
    '/guides-and-advice/dog/',
    '/dog-insurance/dachshund/',
    '/dog-insurance/puppies/',
    '/dog-insurance/patterdale-terrier/',
    '/dog-insurance/sprocker-spaniel/',
    '/dog-insurance/maltipoo/',
    '/dog-insurance/english-bull-terrier/',
    '/dog-insurance/lurcher/',
    '/dog-friendly/',
    '/dog-insurance/cavalier-king-charles-spaniel/',
    '/dog-insurance/miniature-schnauzer/',
    '/dog-breeds/',
    '/dog-insurance/pomeranian/',
    '/dog-insurance/staffordshire-bull-terrier/',
    '/dog-insurance/border-terrier/',
    '/dog-insurance/cocker-spaniel/',
    '/dog-insurance/english-bulldog/',
    '/dog-insurance/labrador-retriever/',
    '/dog-insurance/mixed-breed/',
    '/dog-insurance/german-shepherd/',
    '/dog-insurance/french-bulldog/',
    '/dog-insurance/bichon-frise/',
    '/dog-insurance/border-collie/',
    '/dog-insurance/golden-retriever/',
    '/dog-insurance/goldendoodle/',
    '/dog-insurance/lifetime-lite/',
    '/dog-insurance/poodle/',
    '/dog-insurance/rottweiler/',
    '/dog-insurance/whippet/',
    '/dog-insurance/beagle/',
    '/dog-insurance/cavapoo/',
    '/dog-insurance/lifetime/',
    '/dog-insurance/springer-spaniel/',
    '/dog-insurance/hungarian-vizsla/',
    '/dog-insurance/jack-russell-terrier/',
    '/dog-insurance/greyhound/',
    '/dog-insurance/cockapoo/',
    '/dog-insurance/shiba-inu/',
    '/dog-insurance/siberian-husky/',
    '/dog-insurance/belgian-malinois/',
    '/dog-insurance/lifetime-premium/',
    '/dog-insurance/pug/',
    '/dog-insurance/shih-tzu/',
    '/dog-insurance/yorkshire-terrier/',
    '/puppy-insurance/',
  ],
  cat: [
    '/cat-insurance/',
    '/agria-cat-insurance/',
    '/guides-and-advice/autumn-tips-for-cat-owners/',
    '/agria-catwalk/',
    '/guides-and-advice/cat/',
    '/cat-insurance/bengal/',
    '/cat-insurance/sphynx/',
    '/cat-insurance/ragdoll/',
    '/cat-insurance/birman/',
    '/cat-insurance/siamese/',
    '/cat-insurance/abyssinian/',
    '/cat-insurance/persian/',
    '/cat-insurance/siberian/',
    '/cat-insurance/somali/',
    '/cat-insurance/devon-rex/',
    '/cat-insurance/cornish-rex/',
    '/cat-insurance/russian-blue/',
    '/cat-insurance/maine-coon/',
    '/cat-insurance/british-shorthair/',
    '/cat-insurance/american-shorthair/',
    '/cat-insurance/oriental-shorthair/',
    '/kitten-insurance/',
  ],
  equine: [
    '/horse-insurance/',
    '/guides-and-advice/horse/',
    '/horse-insurance/older-horses/',
    '/carbon-calculator-horses/',
  ],
  rabbit: [
    '/rabbit-insurance/',
    '/guides-and-advice/understanding-your-pet-rabbit/',
    '/guides-and-advice/most-expensive-rabbit-insurance-claims/',
    '/guides-and-advice/outdoor-rabbits-in-winter/',
    '/guides-and-advice/rabbit/',
  ],
};

export const speciesUrls = new Map(
  Object.entries(urlsBySpecies).flatMap(([species, urls]) =>
    urls.map((url) => [url, species]),
  ),
);
